module.exports = __webpack_public_path__ + "img/bookshelf15.42d98a48.jpg";